import { Link } from 'react-router-dom';

export function NichtGefunden() {
  return (
    <div className="seite">
      <h1>Seite nicht gefunden</h1>
      <p>Diese Adresse gibt es im Portal nicht.</p>
      <p>
        <Link to="/">Zur Karte</Link>
      </p>
    </div>
  );
}
